import * as React from 'react';
import TextInput, { Props as TextInputProps } from '@af-common/Common/_components/TextInput';
import DelayedTextInputContainer from '@af-common/Common/_containers/DelayedTextInputContainer';
import { Trans } from 'react-i18next';

export type Props = {
	moduleId?: string
	width?: number
	height?: number
	rotation?: number
	isAttached?: boolean
	onRotationChange?: (rotation: number) => void
} & TextInputProps

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class ModuleRotation extends React.Component<Props> {
	static defaultProps = {
		label: <T>Rotation</T>
	}

	render = () => {
		const {moduleId, rotation, isAttached, onRotationChange, ...props} = this.props;
		return <div className="module-rotation"><DelayedTextInputContainer step={1} type="number" label={this.props.label} onChange={(value:number) => onRotationChange(value)} value={String(this.props.rotation)} {...props}/></div>
	}
}